module.exports = [{"role":"Full Stack Software Engineer","translated":"Informaticien - Développeur d'application (H/F)","url":"/offre-d-emploi"}]


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/public/job-list.json
// module id = 784
// module chunks = 5 7